import Hero from "../components/Hero";

/**
 * HomePage is the parent component that displays welcome message and options.
 *
 * @returns {JSX.Element} - A parent component for the Hero's welcome message and options.
 */

const HomePage = () => {
  return (
    <>
      <Hero />
    </>
  )
};

export default HomePage;